<template>
  <v-hover v-slot="{ hover }">
    <v-card :elevation="hover ? 6 : 2" class="action-card">
      <v-card-text>
        <slot></slot>
      </v-card-text>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: "ActionCard",
};
</script>

<style lang="scss" scoped>
.action-card {
  width: 100%;
  transition: box-shadow 0.2s ease-in-out;
  padding: 20px 0px;

  &:hover {
    cursor: pointer;
  }

}
</style>
